var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAdLogo = function SvgAdLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 584 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 132.14h28.17V1.28H5.9C2.64 1.28 0 3.93 0 7.19v124.96-.01ZM90.28 76.4c3.01 3.07 4.86 7.26 4.86 11.89 0 9.39-7.61 17-17 17s-16.76-7.38-16.99-16.58H33.02c.23 24.72 20.33 44.7 45.11 44.7s45.12-20.2 45.12-45.12c0-12.4-5-23.62-13.1-31.78L90.26 76.4h.02Z",
    fill: "#000035"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.36 1.28h-85.9v26.87h85.9V1.28Z",
    fill: "#EC1F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.46 28.15 66.67 54.94c-1.82 1.82-1.82 4.78 0 6.61l15.7 15.7 37.99-37.99V28.15H93.46ZM428.589.58v84.08c0 8.46-6.879 15.34-15.339 15.34h-14.911V.67L362.87.58V100h-29.88V.67L297.52.58v130.98l118.66.03c26.4-.01 47.88-21.5 47.88-47.91V.66L428.589.57v.01ZM571.94.58H477.8v31.65h70.26v99.33h35.47V12.17c0-6.39-5.2-11.59-11.59-11.59ZM270.85.58 162.42.54c-.07 19.38-.03 74.51-.04 93.89 0 3.19-.66 3.82-3.96 3.79h-15.61v33.12c8.22-.08 18.84.07 27.06-.1 2.57-.05 5.2-.58 7.66-1.33 10.24-3.12 21.4-14.85 21.05-29.6V32.23h48.39v99.33h35.47V12.17c0-6.39-5.2-11.59-11.59-11.59Z",
    fill: "#000035"
  })));
};

export default SvgAdLogo;